import React, { ChangeEventHandler } from "react";
import styled from "styled-components";
import { TextInput, Theme, colors } from "@literati/public-ui-shared-react";
import { ShippingKey } from "components/Shipping/shippingTypes";

export const SHIPPING_FIELDS_CLASS_BASE = "shipping-fields";
export const ShippingFieldsClassName = {
  BASE: SHIPPING_FIELDS_CLASS_BASE,
} as const;

export interface ShippingFieldsProps {
  autoFocus?: boolean;
  className?: string;
  onChange?: ChangeEventHandler<HTMLInputElement>;
}

const StyledP = styled.p`
  margin: 0.625rem 0 0;
  font-size: 0.75rem;
  color: ${colors.warmGray4};
`;

const AddressContainer = styled.div`
  margin: 1rem 0 0;
  display: grid;
  gap: 0.875rem;
  grid-template-columns: calc(50% - 0.4375rem) calc(50% - 0.4375rem);
  grid-template-rows: auto;
  grid-template-areas:
    "street1 street1"
    "street2 street2"
    "city city"
    "state state"
    "postalCode postalCode";

  /* Breakpoint unsupported by PUSR */
  @media (min-width: 375px) {
    grid-template-areas:
      "street1 street1"
      "street2 street2"
      "city city"
      "state postalCode";
  }
`;

const GridItemStreet1 = styled.div`
  grid-area: street1;
`;
const GridItemStreet2 = styled.div`
  grid-area: street2;
`;
const GridItemCity = styled.div`
  grid-area: city;
`;
const GridItemState = styled.div`
  grid-area: state;
`;
const GridItemPostalCode = styled.div`
  grid-area: postalCode;
`;

export const ShippingFields = ({
  autoFocus = true,
  className = "",
  onChange,
}: ShippingFieldsProps) => {
  const cls = ShippingFieldsClassName;
  return (
    <Theme>
      <section className={`${cls.BASE} ${className}`}>
        <TextInput
          autoFocus={autoFocus}
          data-testid="shippingName"
          label="Shipping Name"
          name={ShippingKey.NAME}
          onChange={onChange}
          placeholder="Shipping Name"
        />
        <StyledP>
          Suggestion: Enter the Child’s name here for a nice surprise!
        </StyledP>
        <AddressContainer>
          <GridItemStreet1>
            <TextInput
              data-testid="address"
              label="Address"
              name={ShippingKey.STREET1}
              onChange={onChange}
              placeholder="Address"
            />
          </GridItemStreet1>
          <GridItemStreet2>
            <TextInput
              label="Address Line 2 (unit, suite, etc.)"
              name={ShippingKey.STREET2}
              onChange={onChange}
              placeholder="Address Line 2 (unit, suite, etc.)"
            />
          </GridItemStreet2>
          <GridItemCity>
            <TextInput
              data-testid="city"
              label="City"
              name={ShippingKey.CITY}
              onChange={onChange}
              placeholder="City"
            />
          </GridItemCity>
          <GridItemState>
            <TextInput
              data-testid="state"
              label="State"
              name={ShippingKey.STATE}
              onChange={onChange}
              placeholder="State"
            />
          </GridItemState>
          <GridItemPostalCode>
            <TextInput
              data-testid="zip"
              label="Zip Code"
              name={ShippingKey.POSTAL_CODE}
              onChange={onChange}
              placeholder="Zip Code"
            />
          </GridItemPostalCode>
        </AddressContainer>
      </section>
    </Theme>
  );
};

export default ShippingFields;
